import React from 'react';
import { useToastStore } from '../../store/toastStore';
import Toast from './Toast';

/**
 * Toast Container Component
 * 
 * Displays toast notifications in a fixed position (top-right by default).
 * Automatically removes toasts after their duration expires.
 */
export default function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed top-4 right-4 z-50 max-w-md w-full space-y-2 pointer-events-none"
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast toast={toast} onRemove={removeToast} />
        </div>
      ))}
    </div>
  );
}






